import { render, staticRenderFns } from "./CampaignBuilderMergeableTextArea.vue?vue&type=template&id=645ba2b5"
import script from "./CampaignBuilderMergeableTextArea.vue?vue&type=script&lang=js"
export * from "./CampaignBuilderMergeableTextArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports